import { Grid, GridItem, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import type { CountryDropdownItem, ProfileData } from "libs/codegen/property-onboarding";
import { DropdownField } from "../form/DropdownField";
import { TextField } from "../form/TextField";
import { emptyLocationDropdownItem } from "../location/manual/constants";
import { useStaticDataAtomValue } from "../staticDataAtom";

export const CompanyDetailsController = () => {
    const {
        cmsData: {
            profile: {
                companyLegalDetails,
                companyName,
                companyNameRequired,
                companyAddress,
                companyAddressRequired,
                country,
                countryRequired,
                zipCode,
                zipCodeRequired,
            },
        },
    } = useStaticDataAtomValue();
    const { countriesList } = useStaticDataAtomValue();

    return (
        <VStack gap="24">
            <Typography variant="heading-default">{companyLegalDetails}</Typography>
            <VStack gap="16" backgroundColor="base.inset" p="16" borderRadius="8">
                <TextField<ProfileData>
                    label={companyName}
                    field="companyDetails.name"
                    rules={{
                        required: companyNameRequired,
                    }}
                    dataElementName="company-name"
                />
                <TextField<ProfileData>
                    label={companyAddress}
                    field="companyDetails.address"
                    rules={{
                        required: companyAddressRequired,
                    }}
                    dataElementName="company-address"
                />
                <Grid spacing="16">
                    <GridItem sm={12} md={6}>
                        <DropdownField<ProfileData, CountryDropdownItem>
                            label={country}
                            field="companyDetails.country"
                            items={countriesList}
                            defaultValue={emptyLocationDropdownItem}
                            identifyBy="iso2"
                            rules={{
                                required: countryRequired,
                            }}
                            dataElementName="company-country"
                        />
                    </GridItem>
                    <GridItem sm={12} md={6}>
                        <TextField<ProfileData>
                            label={zipCode}
                            field="companyDetails.postalCode"
                            rules={{
                                required: zipCodeRequired,
                            }}
                            dataElementName="company-zip-code"
                        />
                    </GridItem>
                </Grid>
            </VStack>
        </VStack>
    );
};
